import script from "./HrTagList.vue?vue&type=script&setup=true&lang=js"
export * from "./HrTagList.vue?vue&type=script&setup=true&lang=js"

import "./HrTagList.vue?vue&type=style&index=0&id=d9d1644c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9d1644c"]])

export default __exports__